<div class="accordion">
  <div class="header" (click)="toggle()">
    <ng-content select="[slot=header]"></ng-content>
    <i class="ifc-custom ifc-chevron_down" [class.rotate]="opened"></i>
  </div>
  <div class="body" [class.hidden]="!opened">
    <ng-content select="[slot=body]"></ng-content>
  </div>
</div>
